module.exports = "<div class=\"gallery-container content-box\">\r\n  <a *ngFor=\"let item of viewData\" [routerLink]=\"linksToThought ? ['/thoughts/', item.thoughtId] : null\"><img [src]=\"item.src\" class=\"gallery-item\"></a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/collection-module/view/gallery/gallery.component.html
// module id = ../../../../../src/app/collection-module/view/gallery/gallery.component.html
// module chunks = main